import { render, staticRenderFns } from "./GestionarPropuestasCompras.vue?vue&type=template&id=d590bc24&scoped=true"
import script from "./GestionarPropuestasCompras.vue?vue&type=script&lang=js"
export * from "./GestionarPropuestasCompras.vue?vue&type=script&lang=js"
import style0 from "./GestionarPropuestasCompras.vue?vue&type=style&index=0&id=d590bc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d590bc24",
  null
  
)

export default component.exports